/**
 * 订单编辑
 */
import http from './http';

// 预订单编辑详情
export const getReserveOrderDetail = (data) => {
  return http({
    method: 'POST',
    url: '/reservation/modify/detail',
    data,
  });
};

// 预订单编辑提交
export const modifyReserveOrder = (data) => {
  return http({
    method: 'PUT',
    url: '/reservation/modify',
    data,
  });
};

// 入住单编辑详情
export const getCheckInOrderDetail = (data) => {
  return http({
    method: 'POST',
    url: '/check-in/modify/detail',
    data,
  });
};

// 入住单编辑提交
export const modifyCheckInOrder = (data) => {
  return http({
    method: 'PUT',
    url: '/check-in/modify',
    data,
  });
};

// 续住单编辑详情
export const getRenewalOrderDetail = (params) => {
  return http({
    method: 'GET',
    url: '/extension/modify/detail',
    params,
  });
};

// 续住单编辑提交
export const modifyRenewalOrder = (data) => {
  return http({
    method: 'PUT',
    url: '/extension/modify',
    data,
  });
};

// 取消续住
export const cancelRenewalOrder = (params) => {
  return http({
    method: 'PUT',
    url: '/extension/cancel',
    params,
  });
};

// 直连续住撤回
export const rollbackDirectRenewal = (extensionId) => {
  return http({
    method: 'GET',
    url: `/extension/zl/rollback/${extensionId}`,
  });
};
